module.exports = "/_next/static/images/cc569e05ab7278314f3a0fa3b2a12d0c-man-with-cellphone-lg@2x.jpg";